<template>
  <div
    v-if="!networkError"
    class="github"
  >
    <LoaderImg v-if="!githubData" />
    <div
      v-if="githubData"
      class="github-list"
    >
      <article
        v-for="(repo, index) in githubData"
        :key="index"
        class="block"
      >
        <h3 class="name">
          <a
            :href="repo.html_url"
            target="_blank"
          >{{ repo.name }}</a>
        </h3>
        <p>{{ repo.description }}</p>
        <p v-if="repo.homepage">
          <a
            class="homepage"
            :href="repo.homepage"
            target="_blank"
          >{{ repo.homepage }}</a>
        </p>

        <div class="stats">
          <span class="stars">
            <StarSvg />{{ repo.stargazers_count }}{{ ' ' }}
          </span>
          <span class="forks">
            <ForkSvg />{{ repo.forks_count }}{{ ' ' }}
          </span>
        </div>
      </article>
      <article class="block">
        <GithubUser />
      </article>
    </div>
  </div>
</template>

<script>
  import LoaderImg from '../components/LoaderImg.vue'
  import StarSvg from './svg/StarSvg.vue'
  import ForkSvg from './svg/ForkSvg.vue'
  import GithubUser from './GithubUser.vue'

  export default {
    name: 'GithubStars',
    components: {
      LoaderImg,
      ForkSvg,
      StarSvg,
      GithubUser,
    },
    data: () => ({
      githubData: null,
      networkError: false,
    }),
    mounted() {
      this.getGithubData()
    },
    methods: {
      async getGithubData() {
        try {
          const res = await fetch('https://api.github.com/users/digitaldonkey/repos?per_page=100')
          if (!res.ok) {
            throw new Error(`GitHub request failed: ${res.status}`)
          }
          // Exclude drupal Ethereum (is=65398116)
          const githubData = (await res.json())
            .filter(repo => repo.archived === false && repo.stargazers_count > 1 && repo.id !== 65398116)
            .sort((a, b) => b.stargazers_count - a.stargazers_count)
          // Fewer cards on small screens.
          this.githubData = githubData.slice(0, document.documentElement.clientWidth <= 591 ? 3 : 5)
        }
        catch (e) {
          this.networkError = true
          throw e
        }
      },
    },
  }
</script>

<style>
  .github {
    font-family: Verdana, "Lucida Sans Unicode", sans-serif;
    font-size: 14px;
    color: #222;
    max-width: 75em;
    margin: 0 auto;
  }
  .github .github-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .block {
    width: 18em;
    padding: 1em 1.25em;
    margin: .8em;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .12), 0 1px 2px rgba(0, 0, 0, .24);
    transition: all .3s cubic-bezier(.25, .8, .25, 1);
    border-top: 1px solid rgba(0, 0, 0, .1);
  }
  .block:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, .25), 0 10px 10px rgba(0, 0, 0, .22);
  }
  .block .name {
    font-size: 17px;
    margin-top: 0;
  }
  .block .name > a {
    color: var(--dm-green-dark, #1c7e35);
  }
  .block .stats > span {
    margin-right: 1em;
  }
  .block .homepage {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    white-space: pre;
    text-overflow: ellipsis;
    font-size: small;
    color: #222;
  }
</style>
